import type { Ayah } from '../types'

interface Reciter {
  identifier: string
  name: string
}

export const RECITERS: Reciter[] = [
  { identifier: 'sudais', name: 'Abdurrahmaan As-Sudais' },
  { identifier: 'shuraym', name: 'Saud Ash-Shuraym' },
  { identifier: 'ghamadi', name: 'Saad Al-Ghamdi' },
  { identifier: 'alijaber', name: 'Ali Jaber' },
  { identifier: 'husary', name: 'Mahmoud Khalil Al-Husary' },
]

// Resolve the CDN base URL for audio assets. VITE_APP_URL is the explicit
// override; when it isn't set (every deployed environment to date — the var
// was never wired), we derive the CDN host from VITE_API_URL by stripping the
// `api.` subdomain (e.g. https://api.qlearn.smndiaye.com → https://qlearn.smndiaye.com).
// This mirrors the assets-proxy logic in vite.config.ts so dev and prod agree.
// Returns '' as a last-resort so callers that want to gate on "do we have a
// base?" still can — but in practice one of the two env vars is always set
// in any environment that actually serves the app.
export function resolveAssetsBase(): string {
  const explicit = import.meta.env.VITE_APP_URL
  if (explicit) return explicit
  const apiUrl = import.meta.env.VITE_API_URL
  if (!apiUrl) return ''
  try {
    const u = new URL(apiUrl)
    u.hostname = u.hostname.replace(/^api\./, '')
    return `${u.protocol}//${u.hostname}`
  } catch {
    return ''
  }
}

export function getAudioUrl(reciterId: string, ayah: Ayah): string {
  const baseUrl = resolveAssetsBase()
  const surah = String(ayah.surahNumber).padStart(3, '0')
  const ayahNum = String(ayah.ayahNumber).padStart(3, '0')
  return `${baseUrl}/audio/${reciterId}/${surah}${ayahNum}.mp3`
}
